import axios from "axios"
import Constants from "./constants"
import Storage from "./storage"


export async function GetDBv3Token(idToken, uniqueName, sessionID, userRole) {
    const dbV3Url = `${process.env.REACT_APP_4PC_API}/Authenticate`
    const dbV3Config = {
        headers: {
            'Content-Type': 'application/json',
            'id_token': idToken
        }
    }
    const dbV3Data = {
        'userId': uniqueName,
        'sessionId': sessionID,
        'userRole': userRole
    }
    const response = await axios.post(dbV3Url, dbV3Data, dbV3Config)
    const DBv3Token = response.data
    if (DBv3Token) Storage.setItem(Constants.dbV3Token, DBv3Token.token)
    else console.error(`[ERROR] DashboardV3 Authentication Response ${response.status}`)
}